module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8DHmqG/tc-custom/9781605506678.jpg?1718106014815",
      "alt": "This image is the cover for the book Everything Cake Mix Cookbook, The Everything Books"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Everything Cake Mix Cookbook, The Everything Books\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Think of delicious Pumpkin Bread, Chocolate Hazelnut Cake, and Cheddar Herb Scones homemade from scratch. But who has that kind of time? You can cut your kitchen duty considerably by using the secret ingredient: cake mix! In this unique cookbook, author "), _c('b', [_vm._v("Sarah K. Sawyer")]), _vm._v(" shows readers how to bake all of the classics—and some new surprises—using cake mix. Recipes include:"), _c('br'), _vm._v("French Toast CasseroleRocky Road BarsPotato PancakesGreen Tea CupcakesRhubarb Strawberry Crumble"), _c('br'), _vm._v("Complete with chapters for vegetarians, vegans, and those who have food allergies, this is the perfect cookbook for anyone who wants to cut corners but still present a delicious homemade product. No one will ever know that it’s only semi-homemade!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sarah K. Sawyer\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Adams Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0